import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxBanking from '../util/remote/ajaxBanking';

const initialState = { 
    bankListing: null,
    recentTransaction: null,
    transactions: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    quickStats: null,
};

const reducer = (state, action) => {

  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }

};


const BankingContext = createContext();

export const BankingProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [filters, setFilters] = useState({  
    direction: '',
    payment_type: '',
    ledger_posted: '',
    date_from: '',
    date_to: '', });


   useEffect(()=>{
      if(state.mounted){
        getCheckingTransactions(false, true);
      }
    }, [state.currentPage, state.mounted])
 
  
  const getBanks = async (refresh) => {
    if(Array.isArray(state.bankListing) && !refresh){
      return;
    }
    dispatch({ type: 'bankListing', payload: null });
    const server_response = await ajaxBanking.listBanks();
    if(server_response.status === "OK"){
      dispatch({ type: 'bankListing', payload: server_response.details });
    }else{
      dispatch({ type: 'bankListing', payload: '404' });
    }
  }

  const getRecentTransactions = async (refresh) => {
    if(Array.isArray(state.recentTransaction) && !refresh){
      return;
    }
    const server_response = await ajaxBanking.listRecentTransactions();
    if(server_response.status === "OK"){
      dispatch({ type: 'recentTransaction', payload: server_response.details });
    }else{
      dispatch({ type: 'recentTransaction', payload: '404' });
    }
  }

  const getCheckingTransactions = async (refresh = false, nextPage = false) => {
    if(!refresh && Array.isArray(state.transactions) && !nextPage) return;
    if(refresh){
        setCurrentPage(1);
        dispatch({ type: 'transactions', payload: null });
        dispatch({ type: 'metaData', payload: null });
    }
    const server_response  = await ajaxBanking.fetchCheckingRecords({ page: refresh ? 1 : state.currentPage, criteria: filters });
    if(server_response.status === "OK"){
        dispatch({ type: 'transactions', payload: server_response.details.data });
        dispatch({ type: 'metaData', payload: server_response.details.meta });
    }else{
        dispatch({ type: 'transactions', payload: '404' });
        dispatch({ type: 'metaData', payload: null });
    }
  };

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const setMounted = (value) => {
    dispatch({ type: 'mounted', payload: value });
  };


  const getQuickStats = async (refresh) => {
    if(state.quickStats && !refresh) return;
     dispatch({ type: 'quickStats', payload: null });
    const server_response = await ajaxBanking.fetchCheckingStat();
    if(server_response.status === "OK"){
      dispatch({ type: 'quickStats', payload: server_response.details });
    }else{
      dispatch({ type: 'quickStats', payload: '404' });
    }
  };

  return(
    <BankingContext.Provider value={{
      ...state,
      filters,
      setMounted, 
      dispatch, 
      getBanks,
      getRecentTransactions,
      setCurrentPage,
      getCheckingTransactions,
      setFilters,
      getQuickStats,
      }}>
      {children}
    </BankingContext.Provider>
  )

}

export const useBanking = ()=>useContext(BankingContext);

